import { t } from "@lingui/core/macro";
import { inferAttachmentMimeType } from "@rakazo/core";
import { readFileAsBase64 } from "./pending-attachments";
import type { createSpaceRpc } from "./rpc";

/** Uploads chat attachments to a bot or group chat and returns their artifact ids in order. */
export async function uploadAttachments(
  rpc: Pick<ReturnType<typeof createSpaceRpc>, "artifacts">,
  files: readonly File[],
  target: { botId: string } | { groupId: string },
  confirmed: Array<string | undefined> = [],
): Promise<string[]> {
  const artifactIds: string[] = [];
  for (const [index, file] of files.entries()) {
    const previous = confirmed[index];
    if (previous) {
      artifactIds.push(previous);
      continue;
    }
    const mimeType = inferAttachmentMimeType(file.name, file.type);
    if (!mimeType) throw new Error(t`Unsupported file type: ${file.name}`);
    const contentBase64 = await readFileAsBase64(file);
    const artifact = await rpc.artifacts.create({
      ...target,
      name: file.name,
      mimeType,
      contentBase64,
    });
    confirmed[index] = artifact.id;
    artifactIds.push(artifact.id);
  }
  return artifactIds;
}
